import { gql } from "@apollo/client";

export const CONFIRM_REMITTANCE = gql`
  mutation confirmRemittance($input: RemittanceConfirmInput!) {
    results: confirmRemittance(input: $input) {
      code
      message
      data {
        _id
        clientUID
        amountToRemit
        type
      }
    }
  }
`;